import { formatApiError } from "./api";

/** Format a Date as YYYY-MM-DD using LOCAL calendar parts (never toISOString, which shifts by timezone). */
export const toISODate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** Parse YYYY-MM-DD as a local-midnight Date (new Date("2026-06-10") would be UTC and drift a day). */
export const fromISODate = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const fmtDay = (iso, opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" }) =>
  fromISODate(iso).toLocaleDateString("en-IN", opts);

export const newIdempotencyKey = () =>
  (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `k-${Date.now()}-${Math.random().toString(36).slice(2)}`);

/** Booking access tokens (for guests who booked without an account) are kept per-browser. */
const tokenKey = (id) => `bk_token_${id}`;
export const saveBookingToken = (id, token) => {
  try { localStorage.setItem(tokenKey(id), token); } catch { /* storage unavailable */ }
};
export const getBookingToken = (id) => {
  try { return localStorage.getItem(tokenKey(id)) || ""; } catch { return ""; }
};

/** Friendly message from an API error. Engine errors are {code, detail}; never show raw internals. */
export function errorMessage(e, fallback = "We couldn't complete your booking right now. Please try again.") {
  const data = e?.response?.data;
  if (!data) return fallback;
  if (data.code === "server_error") return fallback;
  if (typeof data.detail === "string") return data.detail;
  return formatApiError(data.detail) || fallback;
}

export const STATUS_LABEL = {
  pending: "Pending", confirmed: "Confirmed", checked_in: "Checked in", completed: "Completed",
  cancelled: "Cancelled", no_show: "No-show", expired: "Expired",
};

export const STATUS_STYLE = {
  pending: "text-yellow-400 border-yellow-400/30",
  confirmed: "text-green-400 border-green-400/30",
  checked_in: "text-sky-400 border-sky-400/30",
  completed: "text-blue-400 border-blue-400/30",
  cancelled: "text-red-400 border-red-400/30",
  no_show: "text-orange-400 border-orange-400/30",
  expired: "text-white/40 border-white/20",
};

export const PAYMENT_LABEL = {
  not_required: "Pay at property", pending: "Payment pending", paid: "Paid", partially_paid: "Partially paid",
  failed: "Payment failed", refunded: "Refunded", unpaid: "Unpaid",
};
